import gql from 'graphql-tag';

import embeddedIntegrationItemFragment from './embeddedIntegrationItemFragment';

export const integrationItemHierarchyFragment = gql`
  fragment integrationItemHierarchyFragment on IntegrationItemHierarchy {
    dokkioClass
    remoteID
    parentRemoteID
    parentIntegrationItem {
      ...embeddedIntegrationItemFragment
    }
  }
  ${embeddedIntegrationItemFragment}
`;
export default integrationItemHierarchyFragment;
